package br.com.texeratx.boardgametimeapp.ui.screens.games.create

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class CreateGameScreen : Screen {

    @Composable
    override fun Content() {
        val navigator = cafe.adriel.voyager.navigator.LocalNavigator.currentOrThrow
        val viewModel = koinInject<CreateGameViewModel>()
        val state by viewModel.state.collectAsState()

        LaunchedEffect(Unit) {
            viewModel.loadModes()
            viewModel.loadCategories()
            viewModel.loadOwners()
        }

        CreateGameUI(
            state = state,
            modes = viewModel.modes.collectAsState().value,
            isLoadingOptions = viewModel.isLoadingOptions.collectAsState().value,
            onValueChange = viewModel::updateState,
            onOpenCatalogSearch = viewModel::openCatalogSearch,
            onDismissCatalogSearch = viewModel::dismissCatalogSearch,
            onCatalogQueryChange = viewModel::onCatalogQueryChange,
            onCatalogPicked = viewModel::onCatalogPicked,
            onAddOwner = viewModel::addOwner,
            onRemoveOwner = viewModel::removeOwner,
            onSave = {
                viewModel.saveGame { navigator.pop() }
            },
            onBack = { navigator.pop() }
        )
    }
}
